import { useLocation } from '@react-router';
import type { History, Location } from 'history';
import { withWindow } from '@shared/utils/withWindow';
import { buildAuthUrl, buildReturnPath } from '@shared/utils/navigation';

type LocationArg = Location<History.PoorMansUnknown>;

export const useAccountRouteHelper = () => {
  const location = useLocation();
  // generate the sign-in/up link that will take you back to the page you're on
  const signInAndReturnToCurrentPath = () => {
    withWindow(global => {
      global.location.href = buildAuthUrl('/login', buildReturnPath(location));
    });
  };
  const signUpAndReturnToCurrentPath = () => {
    withWindow(global => {
      global.location.href = buildAuthUrl('/signup', buildReturnPath(location));
    });
  };
  const signUpAndGoToPath = (intendedLocation: LocationArg) => {
    withWindow(global => {
      global.location.href = buildAuthUrl('/signup', buildReturnPath(intendedLocation));
    });
  };
  const signInAndGoToPath = (intendedLocation: LocationArg) => {
    withWindow(global => {
      global.location.href = buildAuthUrl('/login', buildReturnPath(intendedLocation));
    });
  };
  return {
    signInAndReturnToCurrentPath,
    signUpAndReturnToCurrentPath,
    signInAndGoToPath,
    signUpAndGoToPath,
  };
};
